import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Sidetittel, Innholdstittel, Systemtittel, Undertittel, Ingress, Normaltekst, Element, Feilmelding, Undertekst, UndertekstBold } from "./../";
import Lenkepanel from "nav-frontend-lenkepanel";
export const _frontmatter = {
  "ingress": "Typografi-pakken vår består av flere tekstkomponenter med forhåndsbestemt størrelse og styling."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#bruk-av-typografi-i-prosjekter"
          }}>{`Bruk av Typografi i prosjekter`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#alle-vekter"
          }}>{`Alle vekter`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#selvbestemt-html-tag"
          }}>{`Selvbestemt HTML-tag`}</a></li></ol></nav>
    <h2 {...{
      "id": "bruk-av-typografi-i-prosjekter"
    }}>{`Bruk av Typografi i prosjekter`}</h2>
    <p>{`For å sikre at prosjektet ditt får riktig typografi bruker typografi-komponenten vår denne CSS-klassen fra `}<inlineCode parentName="p">{`nav-frontend-typografi-style`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.app {
  .typo-normal-mixin();
  color: @navMorkGra;
  font-family: @font-family;
  line-height: @line-height-base;
}
`}</code></pre>
    <p>{`Det antas da at prosjektet er pakket inn under CSS-klassen `}<inlineCode parentName="p">{`.app`}</inlineCode>{` å disse blir da lagt til der. Hvis dette ikke er tilfellet i prosjektet ditt,
kan det være greit å legge til manuelt da man sikrer at hele prosjektet får riktig typografi.
Dette kan gjøres ved å legge til`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-less"
      }}>{`@import (reference) "nav-frontend-typografi-style/src/index.less";
`}</code></pre>
    <p>{`i ønsket less fil og da legge til klassen `}<inlineCode parentName="p">{`app`}</inlineCode>{` på elementet som pakker in prosjektet ditt.`}</p>
    <h2 {...{
      "id": "alle-vekter"
    }}>{`Alle vekter`}</h2>
    <Example mdxType="Example">
  <Sidetittel mdxType="Sidetittel">Sidetittel</Sidetittel>
  <Undertekst mdxType="Undertekst">Font size: 40px</Undertekst>
  <Undertekst mdxType="Undertekst">Line height: 44px</Undertekst>
  <Undertekst mdxType="Undertekst">Font weight: 600 semi bold</Undertekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Sidetittel>Sidetittel</Sidetittel>
<h1 className="typo-sidetittel">Sidetittel</h1>
`}</code></pre>
    <Example mdxType="Example">
  <Innholdstittel mdxType="Innholdstittel">Innholdstittel</Innholdstittel>
  <Undertekst mdxType="Undertekst">Font size: 32px</Undertekst>
  <Undertekst mdxType="Undertekst">Line height: 36px</Undertekst>
  <Undertekst mdxType="Undertekst">Font weight: 600 semi bold</Undertekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Innholdstittel>Innholdstittel</Innholdstittel>
<h1 className="typo-innholdstittel">Innholdstittel</h1>
`}</code></pre>
    <Example mdxType="Example">
  <Systemtittel mdxType="Systemtittel">Systemtittel</Systemtittel>
  <Undertekst mdxType="Undertekst">Font size: 24px</Undertekst>
  <Undertekst mdxType="Undertekst">Line height: 28px</Undertekst>
  <Undertekst mdxType="Undertekst">Font weight: 600 semi bold</Undertekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Systemtittel>Systemtittel</Systemtittel>
<h2 className="typo-systemtittel">Systemtittel</h2>
`}</code></pre>
    <Example mdxType="Example">
  <Undertittel mdxType="Undertittel">Undertittel</Undertittel>
  <Undertekst mdxType="Undertekst">Font size: 20px</Undertekst>
  <Undertekst mdxType="Undertekst">Line height: 25px</Undertekst>
  <Undertekst mdxType="Undertekst">Font weight: 600 semi bold</Undertekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Undertittel>Undertittel</Undertittel>
<h2 className="typo-undertittel">Undertittel</h2>
`}</code></pre>
    <Example mdxType="Example">
  <Ingress mdxType="Ingress">Ingress</Ingress>
  <Undertekst mdxType="Undertekst">Font size: 18px</Undertekst>
  <Undertekst mdxType="Undertekst">Line height: 26px</Undertekst>
  <Undertekst mdxType="Undertekst">Font weight: 400 regular</Undertekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Ingress>Ingress</Ingress>
<p className="typo-ingress">Ingress</p>
`}</code></pre>
    <Example mdxType="Example">
  <Element mdxType="Element">Element</Element>
  <Undertekst mdxType="Undertekst">Font size: 16px</Undertekst>
  <Undertekst mdxType="Undertekst">Line height: 22px</Undertekst>
  <Undertekst mdxType="Undertekst">Font weight: 600 semi bold</Undertekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Element>Element</Element>
<p className="typo-element">Element</p>
`}</code></pre>
    <Example mdxType="Example">
  <Feilmelding mdxType="Feilmelding">Feilmelding</Feilmelding>
  <Undertekst mdxType="Undertekst">Font size: 16px</Undertekst>
  <Undertekst mdxType="Undertekst">Line height: 22px</Undertekst>
  <Undertekst mdxType="Undertekst">Font weight: 600 semi bold</Undertekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Feilmelding>Feilmelding</Feilmelding>
<p className="typo-feilmelding">Feilmelding</p>
`}</code></pre>
    <Example mdxType="Example">
  <Normaltekst mdxType="Normaltekst">Normaltekst</Normaltekst>
  <Undertekst mdxType="Undertekst">Font size: 16px</Undertekst>
  <Undertekst mdxType="Undertekst">Line height: 22px</Undertekst>
  <Undertekst mdxType="Undertekst">Font weight: 400 regular</Undertekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Normaltekst>Normaltekst</Normaltekst>
<p className="typo-normal">Normaltekst</p>
`}</code></pre>
    <Example mdxType="Example">
  <Undertekst mdxType="Undertekst">Undertekst</Undertekst>
  <Undertekst mdxType="Undertekst">Font size: 14px</Undertekst>
  <Undertekst mdxType="Undertekst">Line height: 20px</Undertekst>
  <Undertekst mdxType="Undertekst">Font weight: 400 regular</Undertekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Undertekst>Undertekst</Undertekst>
<p className="typo-undertekst">Undertekst</p>
`}</code></pre>
    <Example mdxType="Example">
  <UndertekstBold mdxType="UndertekstBold">UndertekstBold</UndertekstBold>
  <Undertekst mdxType="Undertekst">Font size: 14px</Undertekst>
  <Undertekst mdxType="Undertekst">Line height: 20px</Undertekst>
  <Undertekst mdxType="Undertekst">Font weight: 600 semi bold</Undertekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<UndertekstBold>UndertekstBold</UndertekstBold>
<p className="typo-undertekst-bold">UndertekstBold</p>
`}</code></pre>
    <h2 {...{
      "id": "selvbestemt-html-tag"
    }}>{`Selvbestemt HTML-tag`}</h2>
    <p>{`Du kan selv bestemme hvilken HTML-tag de forskjellige typografi-vektene skal bruke. For eksempel kan du overstyre `}<inlineCode parentName="p">{`h1`}</inlineCode>{`-defaulten for
`}<inlineCode parentName="p">{`Sidetittel`}</inlineCode>{` med `}<inlineCode parentName="p">{`h4`}</inlineCode>{` slik:`}</p>
    <Example mdxType="Example">
  <Sidetittel tag="h4" mdxType="Sidetittel">Sidetittel</Sidetittel>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Sidetittel tag="h4">Sidetittel</Sidetittel>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      